import { z } from 'zod'

export const USERNAME_MIN_LENGTH = 3
export const USERNAME_MAX_LENGTH = 20

export const UsernameSchema = z
	.string({ required_error: 'Brukarnamn må fyllast ut' })
	.min(USERNAME_MIN_LENGTH, { message: 'Brukarnamnet er for kort' })
	.max(USERNAME_MAX_LENGTH, { message: 'Brukarnamnet er for langt' })
	.regex(/^[a-zA-Z0-9_]+$/, {
		message: 'Brukarnamnet kan berre innehalde bokstavar, tal og understrek',
	})
	// users can type the username in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordSchema = z
	.string({ required_error: 'Passord må fyllast ut' })
	.min(6, { message: 'Passordet er for kort' })
	.max(100, { message: 'Passordet er for langt' })
export const NameSchema = z
	.string({ required_error: 'Namn må fyllast ut' })
	.min(3, { message: 'Namnet er for kort' })
	.max(40, { message: 'Namnet er for langt' })
export const EmailSchema = z
	.string({ required_error: 'E-post må fyllast ut' })
	.email({ message: 'E-postadressa er ugyldig' })
	.min(3, { message: 'E-postadressa er for kort' })
	.max(100, { message: 'E-postadressa er for lang' })
	// users can type the email in any case, but we store it in lowercase
	.transform((value) => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ['confirmPassword'],
				code: 'custom',
				message: 'Passorda må vere like',
			})
		}
	})

export const MobileSchema = z
	.string()
	.min(8, { message: 'Telefonnummer må vere minst 8 siffer' })
	.max(15, { message: 'Telefonnummer kan ikkje vere meir enn 15 siffer' })
	.regex(/^\+?[0-9]+$/, { message: 'Ugyldig telefonnummerformat' })
	.optional()
	.or(z.literal(''))
